import type * as React from "react";
import { memo } from "react";
import { useDispatch } from "react-redux";
import { goToStep } from "~/features/configurator/Linear/redux/actions";
import { Link } from "~/common/components/Link";
import { useTranslation } from "react-i18next";
import EditIcon from "@mui/icons-material/Edit";

const EditButton = ({
  index,
  className = "pt-30",
  onStepChange,
}: {
  index: number;
  className?: string;
  onStepChange?: () => void;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const onClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    dispatch(goToStep(index));
    onStepChange?.();
  };

  return (
    <Link className={className} onClick={onClick}>
      <EditIcon className={"icon-margin"} sx={{ fontSize: 20 }} />
      <span>{t("page.linear.summary.btn.edit")}</span>
    </Link>
  );
};

export default memo(EditButton);
